import { Suspense, lazy, memo } from 'react';

import { DrawOptionsProvider, DrawProvider } from '../../draw/store';
import type { FootballRailOptions, Slot } from '../types';
import { SlotType } from '../types';

import PlaceholderCard from './PlaceholderCard';

import { withErrorBoundary } from '@shared/ErrorBoundary';
import type { LiveMatch } from '@shared-types/match.types';

const MatchContent = lazy(() => import('./MatchContent'));
const MatchDayContent = lazy(() => import('./MatchDayContent'));
const DrawContent = lazy(() => import('./DrawContent'));

const Placeholder = <PlaceholderCard />;

const Card = ({
  slot,
  options,
  liveMatches,
}: {
  slot: Slot;
  options: FootballRailOptions;
  liveMatches: LiveMatch[];
}) => {
  const isMatchSlot = slot.type === SlotType.MATCH;
  const isDrawSlot = slot.type === SlotType.DRAW;
  const isMatchDaySlot = slot.type === SlotType.MATCHDAY;

  if (slot.type === SlotType.PLACEHOLDER) return Placeholder;

  return (
    <Suspense fallback={Placeholder}>
      {isMatchSlot && <MatchContent slot={slot} options={options} />}
      {isMatchDaySlot && <MatchDayContent slot={slot} liveMatches={liveMatches} />}
      {isDrawSlot && (
        <DrawOptionsProvider options={{ drawId: slot.id }}>
          <DrawProvider>
            <DrawContent slot={slot} />
          </DrawProvider>
        </DrawOptionsProvider>
      )}
    </Suspense>
  );
};

export default withErrorBoundary(memo(Card));
